/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_TitleInputs */

const en_team_share_title = /** @type {(inputs: Team_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share Project`)
};

const fr_team_share_title = /** @type {(inputs: Team_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager le projet`)
};

const de_team_share_title = /** @type {(inputs: Team_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt teilen`)
};

const it_team_share_title = /** @type {(inputs: Team_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi progetto`)
};

const ru_team_share_title = /** @type {(inputs: Team_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совместный проект`)
};

const es_team_share_title = /** @type {(inputs: Team_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir proyecto`)
};

const zh_cn2_team_share_title = /** @type {(inputs: Team_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享项目`)
};

const ja_team_share_title = /** @type {(inputs: Team_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを共有`)
};

const hi_team_share_title = /** @type {(inputs: Team_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट साझा करें`)
};

const pt_pt2_team_share_title = /** @type {(inputs: Team_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar Projeto`)
};

/**
* | output |
* | --- |
* | "Share Project" |
*
* @param {Team_Share_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_title = /** @type {((inputs?: Team_Share_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_title(inputs)
	if (locale === "de") return de_team_share_title(inputs)
	if (locale === "it") return it_team_share_title(inputs)
	if (locale === "ru") return ru_team_share_title(inputs)
	if (locale === "es") return es_team_share_title(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_title(inputs)
	if (locale === "ja") return ja_team_share_title(inputs)
	if (locale === "hi") return hi_team_share_title(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_title(inputs)
	return en_team_share_title(inputs)
});